import mParticle from '@mparticle/web-sdk';
import Cookies from 'js-cookie';
import { generateLegacyMarketingHash } from './hash-helpers';

const MPARTICLE_KEY = process.env.MPARTICLE_KEY;

export default {
  login: email => {
    try {
      if (!email) {
        return console.error('email is missing, signing up');
      }
      mParticle.Identity.login({
        userIdentities: {
          email,
          other: generateLegacyMarketingHash(email),
        },
      });
    } catch (e) {
      console.error(e);
    }
  },
  logout: () => {
    try {
      if (MPARTICLE_KEY) {
        mParticle.Identity.logout({});
      }
    } catch (e) {
      console.error(e);
    }
  },
  track: (name, props, type = mParticle.EventType.Other) => {
    const isNativeApp = Cookies.get('isNativeApp');
    if (MPARTICLE_KEY) {
      mParticle.logEvent(name, type, {
        ...props,
        Platform: isNativeApp ? 'App' : 'Web',
      });
    }
  },
  logPageView: (name, props) => {
    const isNativeApp = Cookies.get('isNativeApp');
    if (MPARTICLE_KEY) {
      mParticle.logPageView(name, {
        ...props,
        Platform: isNativeApp ? 'App' : 'Web',
      });
    }
  },
  instance: mParticle,
  eventTypes: mParticle?.EventType,
};
